import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/user_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  screen_name_cont: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'screenName',
  },
  profile_phone_cont: {
    model_name: 'Profile',
    column_type: 'string',
    column_name: 'phone',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('User', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('User', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
